import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.displaysteuerung-rolle-berechtigungen-setzen';
import * as api from '../../../clients/displaysteuerung';

@Injectable()
export class DisplaysteuerungDisplaysteuerungRolleBerechtigungenSetzenEffects {

    DisplaysteuerungRolleBerechtigungenSetzen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_DISPLAYSTEUERUNG_ROLLE_BERECHTIGUNGEN_SETZEN),
        mergeMap((x: ac.PostDisplaysteuerungRolleBerechtigungenSetzenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postDisplaysteuerungRolleBerechtigungenSetzen(x.displaysteuerungRolleBerechtigungenRequest).pipe(
                map((result: any) => {
                    return new ac.PostDisplaysteuerungRolleBerechtigungenSetzenErfolgreichAction(result, x.displaysteuerungRolleBerechtigungenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostDisplaysteuerungRolleBerechtigungenSetzenFehlerAction(error, x.displaysteuerungRolleBerechtigungenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.DisplaysteuerungCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.DisplaysteuerungCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.DisplaysteuerungCommandService);
        }
        return this.service;
    }
}
